import { useSelector } from "react-redux";
import { useMemo } from "react";
import Link from "next/link";
import clsx from "clsx";
import Icon from "../../../common/icon";
import styles from "./index.module.scss";

export default function SectionsTree({ filterUrl = "", sectionId }) {
  const { sections } = useSelector((state) => state.sections);
  const sectionsTree = useMemo(() => {
    // eslint-disable-next-line no-use-before-define
    return getSectionsTree(sections);
  }, [sections]);

  return (
    <div className={styles.Right}>
      <ul className={styles.ParentSections}>
        {sectionsTree.map((section) => (
          <li
            key={section.ID}
            className={clsx(section.ID === sectionId && styles.Selected)}
          >
            <Link
              href={
                section.SECTION_PAGE_URL +
                (section.CHILD?.length > 0 ? "" : filterUrl)
              }
            >
              <a>{section.NAME}</a>
            </Link>
            {section.CHILD.length > 0 && (
              <Icon
                id={"arrow"}
                width={8}
                height={14}
                fill={section.ID === sectionId ? "#1247a5" : "#333"}
              />
            )}
          </li>
        ))}
        <li className={clsx(sectionId === 999 && styles.Selected)}>
          <Link href={"/brands/"}>
            <a>Бренды</a>
          </Link>
          <Icon
            id={"arrow"}
            width={8}
            height={14}
            fill={sectionId === 999 ? "#1247a5" : "#333"}
          />
        </li>
      </ul>
    </div>
  );
}

function getSectionsTree(sections, parent = null) {
  return Object.values(sections)
    .filter((section) => section.IBLOCK_SECTION_ID === parent)
    .map((section) => {
      return {
        ...section,
        CHILD:
          section.HAS_CHILDS === "Y"
            ? getSectionsTree(sections, section.ID)
            : [],
      };
    })
    .sort((a, b) => a.SORT - b.SORT);
}
/*
function getSectionsTree(sections, depth) {
    const sectionsCloned = JSON.parse(JSON.stringify(sections));
    for (let sectionId in sectionsCloned) {
        const section = sectionsCloned[sectionId];

        if (section['DEPTH_LEVEL'] != depth) continue;

        const parent = sectionsCloned[section['IBLOCK_SECTION_ID']];

        if (!parent) continue;

        if (typeof parent['CHILD'] === "undefined") {
            parent['CHILD'] = [];
        }
        parent['CHILD'].push(section);
    }

    if (depth > 1) {
        return getSectionsTree(sectionsCloned, depth - 1);
    }
    return Object.values(sectionsCloned).filter(item => item['DEPTH_LEVEL'] == 1)
} */

/*
function getSectionsTree(sections, depth) {
    const sectionsCloned = {...sections};
    const childSections = {}
    for (const sectionId in sectionsCloned) {
        const section = sectionsCloned[sectionId];

        if (section['DEPTH_LEVEL'] != depth) continue;

        if (typeof childSections[section['IBLOCK_SECTION_ID']] === "undefined") {
            childSections[section['IBLOCK_SECTION_ID']] = [];
        }
        childSections[section['IBLOCK_SECTION_ID']].push(section);
    }
    for (const sectionId in childSections) {

    }
    console.log(childSections)
    return Object.values(sectionsCloned)
    if (depth > 1) {
        return getSectionsTree(sectionsCloned, depth - 1);
    }
    return Object.values(sectionsCloned).filter(item => item['DEPTH_LEVEL'] == 1)
} */
